<template>
  <legal-page :content="content" />
</template>

<script>
import LegalPage from '../LegalPage.vue';
import rawMd from './disclaimer.md';

export default {
  name: 'DisclaimerPage',
  components: { LegalPage },
  data() {
    return { content: rawMd };
  }
};
</script>
